<template>
  <div class="recruit">
    <div class="title">
      <span @click="changeType(1)" :class="type==1?'active':''">{{$t('recruit.在招职位')}}</span>
      <span @click="changeType(2)" :class="type==2?'active':''">{{$t('recruit.公司/机构介绍')}}</span>
    </div>
    <div class="box1" v-if="type==1">
      <div
        class="listBox clearfix"
        v-for="(item,i) in list"
        :key="i"
        @click.stop.prevent="gotoDetail(item.id)"
      >
        <div class="leftBox" @mouseenter="anliIndex=i" @mouseleave="anliIndex=null">
          <p class="title1">
            {{item.positionName}} （
            <span>{{item.cityName}}</span>）
          </p>
          <p
            class="title2"
          >{{$t('recruit.经验')}}{{getExperience(item.experience)}}/{{getEducation(item.education)}}/{{getRecruitNature(item.recruitNature)}}</p>
          <div class="hoverBox" v-if="anliIndex == i" @click.stop.prevent>
            <div class="topBox">
              <div class="name1">{{item.positionName}}</div>
              <div class="name2">{{item.nickName}}</div>
            </div>
            <div class="infoBox">
              <div class="infoName">{{$t('recruit.职位描述')}}</div>
              <div class="text" v-html="getHtml(item.positionDes)"></div>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <p
            class="money"
          >{{item.negotiable==1?$t('recruit.面议'):item.salaryBegin+'K-'+item.salaryEnd+"K"}}</p>
          <!-- <p class="time">{{item.auditTime | dateToNow(language)}}{{$t('recruit.发布')}}</p> -->
        </div>
      </div>
      <Loading v-if="loading" />
      <Reload v-if="loadError" @callback="loadMore" />
    </div>
    <div class="box2" v-if="type==2">
      <div class="name">{{companyName}}{{$t('recruit.介绍')}}</div>
      <div class="intro">{{companyInfo}}</div>
      <div class="title" v-if="companyPhoto.length">{{$t('recruit.公司相册')}}</div>
      <ul class="clearfix" v-if="companyPhoto.length">
        <li v-for="(item, i) in companyPhoto" :key="i" v-if="i < 7" @click="openPhoto(i,1)">
          <img :src="item | imageUrl('', 190, 190)" alt />
          <span v-if="companyPhoto.length > 7 && i == 6">+{{ companyPhoto.length - 7 }}</span>
        </li>
      </ul>
      <div class="title" v-if="caseVideo.length || caseImage.length">{{$t('recruit.项目案例')}}</div>
      <div class="videoList" v-if="caseVideo.length || caseImage.length">
        <div class="list" v-if="caseVideo.length" v-for="(item,i) in caseVideo" :key="i">
          <!-- <div class="imgBox">
            <img class="img1" :src="item.url | imageUrl('', 1460, 822)" alt />
            <img class="img2" src="https://image.manamana.net/1646707977000_HpiaAKbp" alt />
          </div>
          <div class="title">{{item.title}}</div>-->
          <video-card v-if="item.id" :item="item" :language="language" :type="2" />
        </div>
        <div class="list" v-if="caseImage.length" v-for="(item,i) in caseImage" :key="i">
          <div class="imgBox">
            <img class="img1" :src="item.path | imageUrl('', 1460, 822)" alt  @click="openPhoto(i,2)" />
          </div>
          <div class="title">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div class="photoBox" v-if="isPhotoBox">
      <div class="pic-container">
        <template v-if="photoList.length > 0">
          <swiper :options="swiperOption" ref="mySwiper" class="home-banner-swiper">
            <!-- slides -->
            <swiper-slide
              v-for="(item, index) of photoList"
              :key="index"
              class="swiper-no-swiping"
              height="100%"
            >
              <span class="videm-img-wrap">
                <img class="videoImg" :src="item | imageUrl()" alt />
              </span>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-prev el-icon-arrow-left"
            @click="prePage"
            v-if="photoList.length != 1"
          ></div>
          <div
            class="swiper-button-next el-icon-arrow-right"
            @click="nextPage"
            v-if="photoList.length != 1"
          ></div>
          <div class="close" @click="isPhotoBox = false">
            <img src="/static/video/photo_close_btn.png" alt />
          </div>
          <div class="page">{{ pageIndex1 }}/{{ photoList.length }}</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import VideoCard from "@/components/v2/peopleCenter/VideoCard";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  metaInfo() {
    return {
      title: "招聘职位 | MANA"
    };
  },
  data() {
    return {
      type: 1,
      isPhotoBox: false,
      pageIndex1: 0,
      swiperOption: {
        autoplay: false,
        noSwiping: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      pageIndex: 1,
      pageSize: 5,
      companyInfo: null,
      companyPhoto: [],
      caseVideo: [],
      caseImage: [],
      companyName: null,
      list: [],
      hasNextPage: false,
      loadError: false,
      loading: false,
      anliIndex: null,
      photoList: []
    };
  },
  components: {
    swiper,
    swiperSlide,
    Reload,
    VideoCard,
    Loading
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  created() {
    this.getList();
    this.getInfo();
    if (this.$route.query.recruitType) {
      this.type = this.$route.query.recruitType;
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    changeType(i) {
      this.type = i;
      this.$router.push({
        path: "/peopleCenter/" + this.$route.params.userId + "/recruit",
        query: {
          recruitType: i
        }
      });
    },
    gotoDetail(id) {
      this.$router.push("/recruitDetail/" + id);
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 150) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getList();
        }
      }
    },
    getExperience(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.1年以下");
      }
      if (i == 3) {
        return this.$t("recruit.1-3年");
      }
      if (i == 4) {
        return this.$t("recruit.3-5年");
      }
      if (i == 5) {
        return this.$t("recruit.5-10年");
      }
      if (i == 6) {
        return this.$t("recruit.10年以上");
      }
    },
    getEducation(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.大专");
      }
      if (i == 3) {
        return this.$t("recruit.本科");
      }
      if (i == 4) {
        return this.$t("recruit.硕士");
      }
      if (i == 5) {
        return this.$t("recruit.博士");
      }
    },
    getRecruitNature(i) {
      if (i == 1) {
        return this.$t("recruit.全职");
      }
      if (i == 2) {
        return this.$t("recruit.实习生");
      }
      if (i == 3) {
        return this.$t("recruit.校招");
      }
      if (i == 4) {
        return this.$t("recruit.兼职");
      }
    },
    getList() {
      this.loading = true;
      let params = {
        userId: this.$route.params.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get("/api/recruit/info/", { params }).then(res => {
        this.loading = false;
        if (res.code == "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.list = [];
          }
          this.hasNextPage = res.data.hasNextPage;
          this.list = [...this.list, ...res.data.list];
        } else {
          this.loadError = true;
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
        }
      });
    },
    getInfo() {
      this.$http
        .get("/api/recruit/info/" + this.$route.params.userId)
        .then(res => {
          if (res.code == "OK") {
            this.companyName = res.data.companyName;
            this.companyInfo = res.data.companyInfo;
            if (res.data.companyPhoto !== "") {
              this.companyPhoto = res.data.companyPhoto.split(",");
            }
            if (res.data.caseVideo) {
              this.caseVideo = res.data.caseVideoDomains;
            }
            if (res.data.caseImage) {
              this.caseImage = JSON.parse(res.data.caseImage);
            }
          }
        });
    },
    openPhoto(i,type) {
      this.photoList = [];
      if (type == 1) {
        this.photoList = this.companyPhoto;
      }
      if (type == 2) {
        for (let i=0;i<this.caseImage.length;i++) {
          this.photoList.push(this.caseImage[i].path)
        }
      }
      this.pageIndex1 = i + 1;
      this.isPhotoBox = true;
      this.$nextTick(() => {
        if (this.photoList.length > 7 && i == 7) {
          this.$refs.mySwiper.swiper.slideTo(0);
        }
        this.$refs.mySwiper.swiper.slideTo(i);
      });
    },
    prePage() {
      if (this.pageIndex1 > 1) {
        this.pageIndex1--;
      }
      return;
    },
    nextPage() {
      if (this.pageIndex1 < this.companyPhoto.length) {
        this.pageIndex1++;
      }
      return;
    }
  }
};
</script>
<style lang="stylus" scoped>
.recruit {
  padding: 30px 0 80px 0;

  .title {
    height: 21px;
    font-size: 15px;
    font-weight: 600;
    color: #B8B8B8;
    line-height: 21px;

    span {
      margin-right: 30px;
      cursor: pointer;
    }

    span.active {
      font-size: 15px;
      font-weight: 600;
      color: #0A0A0A;
    }
  }

  .box1 {
    margin-top: 4px;

    .listBox {
      height: 96px;
      border-bottom: 1px solid #EBEBEB;
      cursor: pointer;

      .leftBox {
        float: left;
        width: 50%;
        position: relative;
        height: 100%;

        .title1 {
          height: 20px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          line-height: 20px;
          margin-bottom: 5px;
          margin-top: 25px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .title2 {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
        }

        .hoverBox {
          position: absolute;
          top: 20px;
          left: 153px;
          width: 424px;
          background: #FFFFFF;
          box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
          border: 1px solid #E5E5E5;
          padding-bottom: 20px;
          z-index: 111;

          .topBox {
            height: 62px;
            background: #F5F4F4;
            padding: 10px 20px 0;

            .name1 {
              height: 24px;
              font-size: 16px;
              font-weight: 600;
              color: #333333;
              line-height: 24px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 10px;
            }

            .name2 {
              height: 18px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .infoBox {
            padding: 0 20px;

            .infoName {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
            }

            .text {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
              height: 130px;
              overflow-y: auto;
            }
          }
        }
      }

      .rightBox {
        float: right;

        .money {
          margin-top: 30px;
          margin-bottom: 5px;
          height: 20px;
          font-size: 14px;
          font-weight: 600;
          color: #FC703E;
          line-height: 20px;
          text-align: right;
        }

        .time {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          text-align: right;
        }
      }
    }
  }

  .box2 {
    margin-top: 30px;

    .name {
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: #000000;
      line-height: 28px;
      margin-bottom: 20px;
    }

    .intro {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      margin-bottom: 40px;
    }

    .title {
      height: 30px;
      font-size: 20px;
      font-weight: 600;
      color: #0A0A0A;
      line-height: 30px;
      margin-bottom: 20px;
    }

    ul {
      margin-bottom: 40px;

      li {
        width: 95px;
        height: 95px;
        float: left;
        margin-right: 10px;
        position: relative;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        img {
          width: 95px;
          height: 95px;
        }

        span {
          position: absolute;
          text-align: center;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          font-size: 20px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          background: rgba(10, 10, 10, 0.69);
          line-height: 95px;
        }
      }
    }

    .videoList {
      .list {
        margin-bottom: 30px;
        cursor: pointer;

        .imgBox {
          width: 730px;
          height: 410px;
          position: relative;

          .img1 {
            width: 730px;
            height: 410px;
          }

          .img2 {
            position: absolute;
            width: 54px;
            height: 70px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .title {
          margin-top: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
        }
      }
    }
  }

  .photoBox {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.85);
    padding: 136px 0 70px 0;
    box-sizing: border-box;

    .close {
      position: absolute;
      top: 70px;
      right: 85px;
      width: 44px;
      height: 44px;
      cursor: pointer;
      z-index: 999999;

      img {
        width: 44px;
        height: 44px;
      }
    }

    .page {
      position: absolute;
      bottom: 25px;
      left: 50%;
      width: 40px;
      margin-left: -20px;
      font-size: 20px;
      color: #999999;
      text-align: center;
    }
  }
}

.pic-container {
  width: calc(100vw - 298px);
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;
  height: 100%;
}

.swiper-container {
  height: 100%;
}

.swiper-button-prev {
  background: none;
  font-size: 0.5rem;
  color: #fff;
  z-index: 1011;
  left: 85px;
  top: 50%;
  width: 44px;
  height: 44px;
  margin-top: -22px;
}

.swiper-button-next {
  background: none;
  font-size: 0.5rem;
  color: #fff;
  z-index: 1011;
  right: 85px;
  top: 50%;
  width: 44px;
  height: 44px;
  margin-top: -22px;
}

.swiper-slide {
  display: table;
}

.videm-img-wrap {
  display: table-cell;
  vertical-align: middle;
  height: calc(100vh - 140px);
}

.videoImg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/step/recruit.vue